<div [class.tw-border-t-2]="dividerTop"
  class="tw-text-gray-700 tw-block tw-px-4 tw-py-2 tw-text-sm hover:tw-bg-gray-100 tw-cursor-pointer " role="menuitem"
  tabindex="-1">
  <ng-content></ng-content>
</div>